import React, { createContext, useContext } from 'react';

import { DrawerType } from '@/components/homepage/components/Header/types';

export type OpenGlobalNavHeaderDrawerFn = (type: DrawerType, isClosable?: boolean, options?: ObjectType) => void;

type GlobalNavHeaderDrawerContextValue = {
  openGlobalNavHeaderDrawer: OpenGlobalNavHeaderDrawerFn;
};

const noop: OpenGlobalNavHeaderDrawerFn = () => {};

const GlobalNavHeaderDrawerContext = createContext<GlobalNavHeaderDrawerContextValue>({
  openGlobalNavHeaderDrawer: noop
});

export const GlobalNavHeaderDrawerProvider = GlobalNavHeaderDrawerContext.Provider;

/** 打开与顶栏绑定的 CommonDrawer（门店 / 邮编 / 日期 / 汉堡菜单等）。须在 GlobalNavHeader 渲染树内使用。 */
export function useOpenGlobalNavHeaderDrawer(): OpenGlobalNavHeaderDrawerFn {
  const { openGlobalNavHeaderDrawer } = useContext(GlobalNavHeaderDrawerContext);
  return openGlobalNavHeaderDrawer;
}
